module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "becproperty-editor"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "reportOpen": _vm.reportOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [(_vm.currentLocale === 'ca') ? _c('span', [_vm._v(_vm._s(_vm.becproperty.name_ca))]) : (_vm.currentLocale === 'en') ? _c('span', [_vm._v(_vm._s(_vm.becproperty.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.becproperty.name_es))]), (_vm.becproperty.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.becproperty.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.becproperty.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.becproperty.date_modified)))])]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.data_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Property_type')) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Name_ca')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becproperty.name_ca),
        expression: "becproperty.name_ca"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becproperty.name_ca)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becproperty.name_ca = $event.target.value
        }, _vm.set_becproperty_name_ca]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Name_en')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becproperty.name_en),
        expression: "becproperty.name_en"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becproperty.name_en)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becproperty.name_en = $event.target.value
        }, _vm.set_becproperty_name_en]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Name_es')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becproperty.name_es),
        expression: "becproperty.name_es"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becproperty.name_es)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becproperty.name_es = $event.target.value
        }, _vm.set_becproperty_name_es]
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v("Números B.E.C.")]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewBecPrice($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_becprice_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), (_vm._.size(_vm.becproperty_becprices) > 0) ? _c('div', [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell",
      attrs: {
        "layout": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprices_table.filter),
        expression: "becprices_table.filter"
      }],
      attrs: {
        "type": "text",
        "placeholder": _vm.filter_placeholder,
        "self": "size-x1",
        "data-intro": "You can filter the data in a datatable by typing in any of the filter fields",
        "data-step": "9",
        "data-position": "top"
      },
      domProps: {
        "value": (_vm.becprices_table.filter)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.becprices_table.filter = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('paginator', {
      attrs: {
        "source": this.object_to_array(_vm.becproperty_becprices),
        "page-size": 20,
        "filter": _vm.becprices_table.filter,
        "data-intro": "Use the paginator to page data for easier viewing",
        "data-step": "10",
        "data-position": "top"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(page) {
          return [_c('datatable', {
            attrs: {
              "id": "data-table-becprices",
              "source": page.data,
              "filterable": false,
              "striped": _vm.becprices_table.striped,
              "editable": _vm.becprices_table.editable,
              "line-numbers": _vm.becprices_table.lineNumbers
            },
            scopedSlots: _vm._u([{
              key: "actions-becprices",
              fn: function(cell) {
                return [_c('table', {
                  staticClass: "actions-table"
                }, [_c('tr', [_c('td', [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.edit_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.editBecPrice(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "pencil",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)]), _vm._v(" "), _c('td', [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.duplicate_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.duplicateBecPrice(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "files-o",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)]), _vm._v(" "), _c('td', [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.delete_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.deleteBecPrice(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "trash-o",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)])])])]
              }
            }])
          }, [_vm._l((_vm.becprices_table.columns), function(column) {
            return _c('datatable-column', {
              attrs: {
                "id": column.id,
                "label": column.label,
                "width": column.width,
                "sortable": column.sortable,
                "groupable": column.groupable,
                "formatter": column.formatter
              }
            })
          }), _vm._v(" "), _c('datatable-column', {
            attrs: {
              "id": "actions-becprices",
              "label": _vm.actions_text,
              "sortable": false,
              "groupable": false
            }
          })], 2)]
        }
      }])
    })], 1)])]) : _vm._e()])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    })])])], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "chevron-left",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentBecProperty({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentBecProperty({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.becproperty.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)], 1)]
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d510a066!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/becproperties/BecPropertyEditor.vue
// module id = 2190
// module chunks = 0